// extracted by mini-css-extract-plugin
module.exports = {"minWidth150":"MoreActions_minWidth150__yO57T"};